import L from 'leaflet';
import { Polygon } from 'react-leaflet';
import { Tooltip } from '../Tooltip/Tooltip';
import React from 'react';
import { getCoordinates } from '../../Services/Entities/Hotspot';
import { getStatusAmounts } from '../../Services/Formatters/TooltipData';

export const renderHotspot = ({
  hotspot,
  layers,
  isClickedLayerHotspot,
  setIsClickedLayerHotspot,
  setHotspotFill,
  onHotspotClick,
  index,
  clickedHotspotId,
  setClickedHotspotId,
  setActiveHotspot,
  dataPoints,
}) => {
  const isLayerHotspot = hotspot.entity_type === 'App\\Models\\Layer';
  const hotspotEntityId = hotspot.entity_id;
  const hotspotInfo = isLayerHotspot && layers[hotspotEntityId];
  const canHover =
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const defaultFill = {
    fill: true,
    fillColor: '#fff',
    fillOpacity: 0.2,
    color: '#fff',
    stroke: '#fff',
    weight: 3,
    opacity: 1,
    className: 'hotspot',
  };

  const coordinates = getCoordinates(hotspot);
  if (coordinates.length === 0) return null;

  const fill = setHotspotFill(hotspot);
  const pathOptions = {
    ...defaultFill,
    ...fill,
  };

  const type = hotspot.entity_type.replace('App\\Models\\', '');
  const key = `${type}-${index}-${hotspotEntityId}-${hotspot.layer_id}`;

  const bounds = L.polygon(coordinates).getBounds();
  const north = bounds.getNorth();
  const centerLng = bounds.getCenter().lng;
  const topCenter = [north, centerLng];
  const shouldShowPopup = hotspotInfo?.show_popup === 1;

  return (
    <Polygon
      key={key}
      positions={coordinates}
      eventHandlers={{
        click: () => {
          setActiveHotspot(null, null);
          setIsClickedLayerHotspot(false);
          return onHotspotClick(hotspot);
        },
        mouseover: () => {
          if (canHover && isLayerHotspot) {
            setClickedHotspotId(hotspotEntityId);
            setIsClickedLayerHotspot(true);
          }
        },
        mouseout: () => {
          if (canHover && isLayerHotspot) {
            setIsClickedLayerHotspot(false);
            setClickedHotspotId(null);
          }
        },
      }}
      pathOptions={pathOptions}
      className={pathOptions.className}
    >
      {shouldShowPopup &&
        canHover &&
        isClickedLayerHotspot &&
        clickedHotspotId === hotspotEntityId &&
        isLayerHotspot && (
          <Tooltip
            name={hotspotInfo?.name}
            position={[...topCenter]}
            statusAmounts={
              isLayerHotspot && dataPoints
                ? getStatusAmounts({
                    tooltipDataPoints: dataPoints,
                    clickedHotspotId: hotspotEntityId,
                  })
                : null
            }
          />
        )}
    </Polygon>
  );
};
